import { stripHtmlTags, trimText } from '../../helpers/utils'

const LANG_ID = 1

export const getUrl = (type, id, phonefk) => {
  return `/${type}/${id}?device=${phonefk}`
}

export const getTitle = source => {
  if (LANG_ID === 1) {
    return source.name
  }
  return source[`name_language_${LANG_ID}`]
}

export const getDescription = source => {
  let description = ''
  if (LANG_ID === 1) {
    description = source.val
  } else {
    description = source[`val_language_${LANG_ID}`]
  }
  if (!description) {
    description = source[`steps_language_${LANG_ID}`]
  }

  if (description && description.length > 0) {
    return trimText(stripHtmlTags(description), 300)
  }
  return ''
}
